module.exports = __webpack_public_path__ + "img/mark_ps_card.b2b27fdb.png";